<template>
  <!-- This component doesn't render anything -->
</template>

<script setup>
  import { watch, onMounted } from 'vue'
  import { useSettingsStore } from '@/stores/settingsStore'

  const settingsStore = useSettingsStore()

  // Check if we're in a browser environment
  const isBrowser = typeof window !== 'undefined'

  if (isBrowser) {
    watch(
      () => [settingsStore.customPrimary, settingsStore.customSecondary],
      () => {
        settingsStore.applyColors()
      },
      { immediate: true },
    )

    onMounted(() => {
      // Apply colors immediately on mount
      settingsStore.applyColors()
    })
  }
</script>
